module.exports = __webpack_public_path__ + "static/media/recentshow.d681fde9.png";